
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FormOption',
  props: {
    option: Object,
    optionType: {
      type: String,
      default: 'color'
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {}
  }
})
